export enum EFsType {
  DOCUMENT_FS = 'DOCUMENT_FS',
  SURVEY_FS = 'SURVEY_FS',
  WORKFLOW_FS = 'WORKFLOW_FS',
}
